import React, { Component } from "react";
import Store from "../../content/Store";
import Content from "../../content/Content";
import PolicyPanel from "./PolicyPanel";
import { Paths } from "./../../constants/UrlConstants";
import { connect } from "react-redux";
import { setSelectedPolicy } from "../../actions/policy/policyActions";
import { GO_TO_PLAN_BUTTON } from "./PolicyConstants";
import Scroll from "react-scroll";
import Button from "../shared/buttons/Button";
import styles from "../../assets/css/modules/policies/choose-your-plan.css";
import { BrandTypes, Layouts } from "../../constants/Constants";

export const mapStateToChooseYourPlan = ({
  accountReducer = {},
  policyReducer = {},
  layoutReducer = {}
}) => {
  return {
    deepLinkingUrl: accountReducer.deepLinkingUrl,
    policies:
      (policyReducer.policyDetails && policyReducer.policyDetails.Policies) ||
      [],
    layout: layoutReducer.layout
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setSelectedPolicy: (policy) => dispatch(setSelectedPolicy(policy))
  };
};

export class ChooseYourPlan extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedPolicyIndex: null
    };
  }

  choosePlan = async () => {
    await this.props.setSelectedPolicy(
      this.props.policies[this.state.selectedPolicyIndex]
    );

    this.props.history.push(this.props.deepLinkingUrl || Paths.HomeRoot);
  };

  changeSelectedPolicy(policyIndex) {
    this.setState({
      selectedPolicyIndex: policyIndex
    });
  }

  setAccessibilityAttributes = (isEnabled, index, membershipNumber) => {
    if (!isEnabled) {
      return {};
    }
    return {
      role: "button",
      tabIndex: "0",
      "aria-pressed": this.state.selectedPolicyIndex === index,
      "aria-label": `Membership Number: ${membershipNumber}`
    };
  };

  render() {
    return (
      <div className="container">
        <div className="row">
          <div className="col-sm-12 col-md-8 offset-md-2 col-lg-6 offset-lg-3 title-margin">
            <h1 className={`axa-headline ${styles.title}`}>
              <Content name={Store.ChooseYourPlan.Title} />
            </h1>
          </div>
        </div>
        <div className="row">
          {this.props.policies.map((policy, index) => {
            const isDisabledInHOLAxaHealth =
              policy.Brand === BrandTypes.AXA &&
              this.props.layout === Layouts.HOL;

            const isEnabled = isDisabledInHOLAxaHealth
              ? false
              : !policy.HasPolicyLapsedForMoreThan3Years;

            return (
              <React.Fragment key={index}>
                <div className="col-sm-12 col-md-8 offset-md-2 col-lg-6 offset-lg-3">
                  <div
                    className="policy_panel"
                    onClick={() => {
                      isEnabled && this.changeSelectedPolicy(index);
                      Scroll.scroller.scrollTo(GO_TO_PLAN_BUTTON, {
                        duration: 750,
                        smooth: true
                      });
                    }}
                    onKeyPress={(e) => {
                      if (e.which === 13 || e.which === 32) {
                        isEnabled && this.changeSelectedPolicy(index);
                        Scroll.scroller.scrollTo(GO_TO_PLAN_BUTTON, {
                          duration: 750,
                          smooth: true
                        });
                      }
                    }}
                    {...this.setAccessibilityAttributes(
                      isEnabled,
                      index,
                      policy.MembershipNumber
                    )}
                  >
                    <PolicyPanel
                      policy={policy}
                      layout={this.props.layout}
                      isSelected={
                        isEnabled && this.state.selectedPolicyIndex === index
                      }
                    />
                  </div>
                </div>
              </React.Fragment>
            );
          })}
        </div>
        <div className="row">
          <div className="col-sm-12 col-md-8 offset-md-2 col-lg-6 offset-lg-3 bottom-margin">
            <Button
              name={GO_TO_PLAN_BUTTON}
              disabled={this.state.selectedPolicyIndex === null}
              onClick={() => this.choosePlan()}
              id="goToPlanBtn"
              label={<Content name={Store.ChooseYourPlan.ButtonText} />}
            />
          </div>
        </div>
      </div>
    );
  }
}

export default connect(
  mapStateToChooseYourPlan,
  mapDispatchToProps
)(ChooseYourPlan);
